import { render, staticRenderFns } from "./ViewDemolition.vue?vue&type=template&id=3ae3d4ed"
import script from "./ViewDemolition.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDemolition.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports